export const PAY_RANGE_SCALE_ORIENTATION = {
  horizontal: "horizontal",
  vertical: "vertical",
};

export const PAY_RANGE_SCALE_ORIENTATIONS = Object.values(
  PAY_RANGE_SCALE_ORIENTATION
);

export const PAY_RANGE_SCALE_STATE = {
  default: "default",
  focused: "focused",
  error: "error",
  changed: "changed",
  disabled: "disabled",
  empty: "empty",
};

export const PAY_RANGE_SCALE_STATES = Object.values(PAY_RANGE_SCALE_STATE);

export const PAY_RANGE_SCALE_STATE_LABELS = {
  [PAY_RANGE_SCALE_STATE.default]: "Default",
  [PAY_RANGE_SCALE_STATE.focused]: "Focused",
  [PAY_RANGE_SCALE_STATE.error]: "Error",
  [PAY_RANGE_SCALE_STATE.changed]: "Changed",
  [PAY_RANGE_SCALE_STATE.disabled]: "Disabled",
  [PAY_RANGE_SCALE_STATE.empty]: "Empty",
};

export const PAY_RANGE_SCALE_ORIENTATION_LABELS = {
  [PAY_RANGE_SCALE_ORIENTATION.horizontal]: "Horizontal",
  [PAY_RANGE_SCALE_ORIENTATION.vertical]: "Vertical",
};
